import {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {shallowEqual, useSelector} from 'react-redux';
import {isUndefined} from 'lodash';
import Logger from '@nl/logger';
import getRouterConfig from '../utils/getRouterConfig';

const useNLTrackers = () => {
	const {pathname} = useLocation();
	const [inited, setInited] = useState(false);
	const getGaaString = (analytics1, analytics2) => {
		let ret = '';
		if (analytics1 && analytics1.indexOf('UA-') !== -1) {
			ret = `${analytics1}${analytics2 ? `,${analytics2}` : ''}`;
		}
		return ret;
	};
	const {
		LOC_RESOURCE,
		SITE,
		LOC_QOS,
		GAA,
		isLoggedIn,
		uid,
		userType,
		tuid,
		tlid,
		mvpduserid,
	} = useSelector(
			(state) => ({
				LOC_RESOURCE: state.config.data.cdn ? `${state.config.data.cdn.secure}base/site/` : '',
				SITE: state.config.data.name,
				LOC_QOS: state.config.data.analytics ? state.config.data.analytics.qos : '',
				GAA: state.config.data.analytics ? getGaaString(state.config.data.analytics.analytics1,
						state.config.data.analytics.analytics2) : '',
				isLoggedIn: state.client.data.isLoggedIn,
				uid: state.client.data.uid,
				userType: state.client.data.userType,
				tuid: state.client.data.trackUsername,
				tlid: state.client.data.trackUserId,
				mvpduserid: state.client.data.mvpduserid,
			}),
			shallowEqual,
	);

	const getNLTrackConfig = () => {
		const nlTrackConfig = {
			locResource: LOC_RESOURCE,
			locQos: LOC_QOS,
			site: SITE,
			gaa: GAA,
		};
		if (isLoggedIn) {
			nlTrackConfig.userType = userType;
			nlTrackConfig.uid = uid;
			if (tuid) {
				nlTrackConfig.tuid = tuid;
			}
			if (tlid) {
				nlTrackConfig.tlid = tlid;
			}
			if (mvpduserid) {
				nlTrackConfig.mvpduserid = mvpduserid;
			}
		}
		return nlTrackConfig;
	};

	useEffect(() => {
		// TODO: Need to use userType to tell if auth ready
		if (getRouterConfig(pathname, 'externalPage') !== true && window.NLTracker && !inited && !isUndefined(userType) && LOC_RESOURCE) {
			try {
				window.NLTracker.initialize(getNLTrackConfig());
			} catch (e) {
				Logger.error(`Init NLTracker error: ${e}`);
			}
			setInited(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userType]);

	useEffect(() => {
		if (getRouterConfig(pathname, 'externalPage') !== true && window.NLTracker && inited && !isUndefined(userType) && LOC_RESOURCE) {
			try {
				window.NLTracker.reInitialize(getNLTrackConfig());
			} catch (e) {
				Logger.error(`Re Init NLTracker error: ${e}`);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uid]);

	useEffect(() => {
		if (getRouterConfig(pathname, 'externalPage') !== true && window.NLTracker && pathname && inited) {
			// TODO: Geo blocked page and error page should NOT send track
			try {
				window.NLTracker.trackPage(pathname);
			} catch (e) {
				Logger.error(`trackPage error: ${e}`);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname, inited]);
};

export default useNLTrackers;
